import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import {
  Row,
  Col,
  Form,
  InputGroup,
  Modal,
  Table,
  Card,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { formatDateTime } from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const UserDetailOffCanvance = (props) => {
  const { postData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [data, setData] = useState({});
  const GetEditData = async (id) => {
    const response = await getData(`/admin/b2b-customer/${id}`);
    setData(response?.data);
  };
  useEffect(() => {
    GetEditData(props.show);
  }, [props.show]);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            User Detail
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="shadow-sm">
            <Card.Body>
              <Row className="mb-3">
                <Col md={4}>
                  <strong>Contact Person Name :- :- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.contact_person_name|| "NA"}</Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <strong>Contact Person Email:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.contact_person_email|| "NA"}</Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <strong>Contact Person Contact No:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.contact_person_contact_no|| "NA"}</Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <strong>Address:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.address|| "NA"}</Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <strong>Landmark:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.landmark|| "NA"}</Col>
              </Row>
              <Row className="mb-3">
                <Col md={4}>
                  <strong>GST Number:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.gst_number|| "NA"}</Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <strong>State:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.State?.name|| "NA"}</Col>
              </Row>
              <Row className="mb-3">
                <Col md={4}>
                  <strong>City:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.City?.name|| "NA"}</Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <strong>Pincode:- </strong>
                </Col>
                <Col md={8}>{data?.User_Detail?.Pincode?.name|| "NA"}</Col>
              </Row>
              <Row className="mb-3">
                <Col md={4}>
                  <strong>Shop Image:</strong>
                </Col>
                <Col md={8}>
                  {data?.User_Detail?.shop_image ? (
                    <img
                      src={`${IMG_URL}${data.User_Detail.shop_image}`}
                      alt="Shop"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  ) : (
                    <span>No Image Available</span>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default UserDetailOffCanvance;
